<script>
		import { createEventDispatcher } from 'svelte';
    import MdcUtils from './MdcUtils';

const dispatch = createEventDispatcher();
export let cash, accounts;
let errors = [], defaultAcctSet = false, claimedAccount = null, toAcct=null

$:if(accounts) {
	if(!defaultAcctSet && accounts.length>0) {
	toAcct = accounts[0]?.id ?? null
	defaultAcctSet = true
	}
}


function close() {
	dispatch('action',{do:'doSelectAccount', account: accounts[toAcct]} )
}

function claimCash() {
	claimedAccount	= accounts[toAcct]
		dispatch('action',{do:'doClaimCash', acct:toAcct, tx:cash.id} )
}

</script>



<div class="modal panel">

	{#if cash.id}
{#if !cash.collected}
<h2>Grab the Cash!</h2>
<p>This cash is available for pickup:</p>
<p>Amount: {MdcUtils.format(cash.amt)}</p>
<p>Description: {cash.msg}</p>
<!-- A select dropdown showing all user's accounts-->
	<label for="grab-cash-account">Select Account</label>
	<select id="grab-cash-account" name="grab-cash-account" bind:value={toAcct}>
		{#each accounts as account}
			<option value={account.id}>{account.title || 'Account created on ' + new Date(account.acct?.ts||Date.now()).toLocaleDateString()} {MdcUtils.format(account.avail)}</option>
		{/each}
	</select>
	<p><button on:click={claimCash}>Pickup cash</button></p>

	{:else}
	<h2>Got it!</h2>
	<p>Cash was successfully deposited.</p> 
	<p style="color:var(--red);" class="clickable" on:click={()=>{dispatch('action',{do:'doSelectAccount', account:accounts[toAcct]})}}>Go to your account</p>
	{/if}
{:else}
<h2>Cash doesn't exist. Was it picked up?</h2>
{/if}
<button on:click={close}>Close</button>

<!-- if account.msgs, display the messages, one per line, in red font-->
{#if errors}
	<div class="leave-cash-msgs">
		{#each errors as error}
			<div class="leave-cash-msg red">
				{error}
			</div>
		{/each}
	</div>
{/if}


</div>

<style>
	
</style>